import styled from "styled-components";

export const AvisosContainer = styled.div<{ temPlano: boolean; liberadaContratacao: boolean }>`
  padding: ${({ temPlano }) => (!temPlano ? "4rem 0 !important" : "")};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ temPlano, liberadaContratacao }) => 
  !temPlano ?
  !liberadaContratacao ? 'white !important'
  : '#f8f8f8' : ''};
  transform: ${({ liberadaContratacao, temPlano }) => !temPlano && !liberadaContratacao ? 'translateY(1rem)' : ''};

  div:first-of-type {
    /* width: ${({ temPlano }) => (!temPlano ? "100%" : "")}; */
    max-width: ${({ temPlano, liberadaContratacao }) => (
      !temPlano 
      ? liberadaContratacao ? "500px" 
      : !liberadaContratacao ? "760px"
      : "" : "")};
  }
  .ant-switch-handle {
    width: 20px !important;
  }

  .title {
    h3 {
      font-weight: 600;
    }
  }
  .divider {
    width: 100%;
    max-width: 80px !important;
    background-color: var(--ant-primary-color);
    height: 2px;
    margin-bottom: 2rem;
  }

  .plan-boxes {
    flex-wrap: nowrap;
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .ant-divider {
    margin: 8px 0;
  }

  .ant-btn {
    height: 56px;

    span {
      font-weight: 500;
      svg {
        display: none;
      }
    }
  }
  .total-contratado {
    display: none;
  }
  .dismiss {
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      color: var(--ant-primary-7);
      transition: 0.3s;
    }
  }

  @media only screen and (max-device-width: 812px) {
    .ant-card-body {
      padding: 16px;
    }
  }
`;
